import { lazy, Suspense } from "react";
import { Redirect, Route, Router as WouterRouter, Switch } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import Home from "@/pages/Home";
import { CookieConsent } from "@/components/CookieConsent";
import AcademyRuntime from "@academy-runtime";

const Programmes = lazy(() => import("@/pages/Programmes"));
const ProgrammeDetail = lazy(() => import("@/pages/ProgrammeDetail"));
const About = lazy(() => import("@/pages/About"));
const Contact = lazy(() => import("@/pages/Contact"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("@/pages/TermsOfService"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const Admin = lazy(() => import("@/pages/Admin"));

const queryClient = new QueryClient();
const basePath = import.meta.env.BASE_URL.replace(/\/$/, "");

function Router() {
  return (
    <Suspense
      fallback={
        <div
          className="flex min-h-[100dvh] items-center justify-center bg-background px-4 text-foreground"
          role="status"
          aria-live="polite"
        >
          Loading…
        </div>
      }
    >
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/programmes" component={Programmes} />
        <Route path="/programmes/:slug" component={ProgrammeDetail} />
        <Route path="/about" component={About} />
        <Route path="/contact" component={Contact} />
        <Route path="/academy/*?" component={AcademyRuntime} />
        <Route path="/sign-in/*?" component={AcademyRuntime} />
        <Route path="/sign-up/*?" component={AcademyRuntime} />
        <Route path="/login/*?">
          <Redirect to="/" />
        </Route>
        <Route path="/register/*?">
          <Redirect to="/" />
        </Route>
        <Route path="/courses/*?">
          <Redirect to="/programmes/teen-ai-builders-academy" />
        </Route>
        <Route path="/reviews">
          <Redirect to="/#reviews" />
        </Route>
        <Route path="/home">
          <Redirect to="/" />
        </Route>
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms-of-service" component={TermsOfService} />
        <Route path="/cookie-policy" component={CookiePolicy} />
        <Route path="/admin" component={Admin} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <WouterRouter base={basePath}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Router />
          <Toaster />
          <CookieConsent />
        </TooltipProvider>
      </QueryClientProvider>
    </WouterRouter>
  );
}

export default App;
